module.exports = __webpack_public_path__ + "media/images/promotions/cards/chance-2-e901773577aca31fbbd0d098286023d0.svg";